import { createTheme } from "@mui/material/styles";

export const customTheme = createTheme({
  typography: {
    fontFamily: ["Roboto", " sans-serif"].join(","),

    h1: {
      fontSize: "36px",
      fontWeight: 900,
      fontFamily: "Swedbank Headline",
    },
    h2: {
      fontSize: "32px",
      fontWeight: 900,
      fontFamily: "Swedbank Headline",
    },
    h3: {
      fontSize: "26px",
      fontWeight: 900,
      fontFamily: "Swedbank Headline",
    },
    h4: {
      fontSize: "20px",
      fontWeight: 900,
      fontFamily: "Swedbank Headline",
    },
    body1: {
      fontSize: "17px",
      fontWeight: 500,
    },
    body2: {
      fontSize: "15px",
      fontWeight: 500,
    },
    body3: {
      fontSize: "12px",
      fontWeight: 400,
    },
  },
  palette: {
    text: {
      color: "#FF5F00",
    },

    // dark is button hover color
    primary: {
      main: "#FF5F00",
      dark: "#ff5f00cc",
    },
    secondary: {
      main: "#31A3AE",
      dark: "#31a3aecc",
    },
    background2: {
      main: "#FDF6EE",
    },
    background3: {
      main: "#FFECFF",
      light: "#FBF3F7",
      dark: "#C5569A",
    },
    background4: {
      main: "#ECF9F3",
    },
    link: {
      main: "#31A3AE",
      dark: "#257886",
      hover: "#257886cc",
    },
    textBlack: {
      main: "#0B0B0B",
    },
    textGrey: {
      main: "#ACACAC",
    },
    button: {
      main: "#512B2B",
    },

    speedometer: {
      red: {
        light: "#FDADA8",
        dark: "#FD7972",
      },
      green: {
        light: "#98DBA7",
        main: "#49C96D",
      },
      blue: {
        main: "#51569F",
        light: "#4973B4",
        lighter: "#66C3E5",
      },
      violet: {
        main: "#845EA1",
        light: "#6E73AF",
        lightest: "#f0f1f7",
      },
      pink: {
        main: "#DF6897",
      },
      orange: {
        light: "#FCAA8D",
      },
      yellow: {
        main: "#FFD240",
      },
      gray: {
        main: "#999999",
        _100: "#EEEDED",
        _200: "#EBEBEB",
        _300: "#C9C9C9",
        _400: "#8A9099",
        _500: "#7C7C7C",
        _600: "#656565",
        _700: "#3F434A",
      },
    },
  },

  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none",
          borderRadius: "3px",
          fontSize: "18px",

          ":hover": {
            boxShadow: "none",
          },
        },

        containedPrimary: {
          ":disabled": {
            backgroundColor: "#ff5f00b3",
            color: "#fff",
          },
        },
        containedSecondary: {
          ":disabled": {
            backgroundColor: "#31a3aecc",
            color: "#fff",
          },
        },
      },
    },

    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#512B2B",
        },
      },
    },
  },
});
